import React, {Component} from "react";
import {Tab, TabList, TabPanel, Tabs} from "react-tabs";
import Container from "../../../modules/commons/Container";
import SimpleDDL from "../../../modules/SimpleDDL";
import BelumPDI from "./belumPDI/belumPDI";
import SudahPDI from "./sudahPDI/sudahPDI";
import Api from "../../../Services/Api";
import SimpleLoadingOverlay from "../../../modules/popup/SimpleLoadingOverlay";
import {mapToObjectDDL} from "../../common/mapper";
import ErrorAction from "../../../Redux/ErrorRedux";
import {connect} from "react-redux";
import {HttpStatus} from "../../common/Constants";
import {fetchDataAsync, getUserAccess} from "../../../Services/Utils";

class Pdi extends Component {
    constructor(props) {
        super(props);
        this.state = {
            kodeCabang: null,
            tabIndex: 0,
            loading: false,
            submittedFilterData: {},
            pagination: {
                totalData: 0,
                page: 1,
                limit: 5,
            },
            belumPDIData: [],
            sudahPDIData: [],
            cabangOptions: [],
            userAccess: {},
        };
    }

    componentDidMount() {
        this.fetchDataCabang();
    }

    fetchDataCabang = async () => {
        if (this.props.menuAccess && this.props.menuAccess.length > 0) {
            let res = await Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang();
            if (res.ok) {
                let filteredData = res.data.data.filter(
                    item => this.props.menuAccess.map(data => data.idRefObj).includes(item.kodeCabang)
                );

                if (filteredData.length !== 0) {
                    let userAccess = getUserAccess(this.props.menuAccess, filteredData[0].kodeCabang);
                    this.setState((prevValue) => ({
                        ...prevValue,
                        cabangOptions: filteredData.map(data => mapToObjectDDL(data.namaDealer, data.kodeCabang)),
                        kodeCabang: mapToObjectDDL(filteredData[0].namaDealer, filteredData[0].kodeCabang),
                        userAccess,
                    }));

                    this.fetchBelumPDI({kodeCabang: filteredData[0]?.kodeCabang});
                }
            }
        }
    }

    componentDidUpdate(_, prevState) {
        if (prevState.tabIndex !== this.state.tabIndex) {
            this.callApi();
        }

        if (
            (prevState.pagination.page !== this.state.pagination.page ||
                prevState.pagination.limit !== this.state.pagination.limit) &&
            !this.state.isFetch
        ) {
            this.callApi();
        }
    }

    fetchBelumPDI = async (filter = {}, page = 1, limit = 5) => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: true,
            submittedFilterData: {...filter},
            isFetch: true,
            pagination: {
                ...prevValue.pagination,
                totalData: 0,
            },
        }));

        const response = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_TRANSACTION").getAllPDI,
            setError: this.props.setError,
            menuName: "Belum PDI",
            args: {
                ...filter,
                page,
                limit,
                kodeCabang: filter.kodeCabang ? filter.kodeCabang : this.state.kodeCabang?.value,
            },
        });
        if (response.ok && response.data.status === HttpStatus.SUCCESS) {
            this.setState((prevValue) => ({
                ...prevValue,
                belumPDIData: response.data.data,
                pagination: {
                    ...prevValue.pagination,
                    totalData: response.data.totalData,
                    limit,
                    page,
                },
            }));
        }

        this.setState((prevValue) => ({...prevValue, loading: false, isFetch: false}));
    };

    fetchSudahPDI = async (filter = {}, page = 1, limit = 5) => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: true,
            submittedFilterData: {...filter},
            isFetch: true,
            pagination: {
                ...prevValue.pagination,
                totalData: 0,
            },
        }));
        const response = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_TRANSACTION").getAllDonePDI,
            setError: this.props.setError,
            menuName: "Sudah PDI",
            args: {
                ...filter,
                page,
                limit,
                kodeCabang: filter.kodeCabang ? filter.kodeCabang : this.state.kodeCabang?.value,
            },
        });
        if (response.ok && response.data.status === HttpStatus.SUCCESS) {
            this.setState((prevValue) => ({
                ...prevValue,
                sudahPDIData: response.data.data,
                pagination: {
                    ...prevValue.pagination,
                    totalData: response.data.totalData,
                    limit,
                    page,
                },
            }));
        }

        this.setState((prevValue) => ({...prevValue, loading: false, isFetch: false}));
    };

    handleCabangChange = async (value) => {
        let userAccess = getUserAccess(this.props.menuAccess, value.value);
        this.setState((prevValue) => ({
            ...prevValue,
            kodeCabang: value,
            pagination: {...prevValue.pagination, page: 1, limit: 5, totalData: 1},
            userAccess,
        }));
        this.callApi(value.value);
    }

    handleSetState = (callback) => {
        this.setState(callback);
    };

    callApi = (kodeCabang) => {
        if (this.state.tabIndex === 0) {
            this.fetchBelumPDI(
                {...this.state.submittedFilterData, kodeCabang},
                this.state.pagination.page,
                this.state.pagination.limit
            );
        } else {
            this.fetchSudahPDI(
                {...this.state.submittedFilterData, kodeCabang},
                this.state.pagination.page,
                this.state.pagination.limit
            );
        }
    };

    render() {
        return (
            <>
                <Container>
                    <SimpleDDL
                        id="select_options_nama_cabang"
                        box="search"
                        name="kodeCabang"
                        containerclassname="width width-350px"
                        placeholder="Nama cabang hak akses"
                        value={this.state.kodeCabang}
                        options={this.state.cabangOptions}
                        onChange={(value) => this.handleCabangChange(value)}
                    />
                    <Tabs
                        selectedIndex={this.state.tabIndex}
                        onSelect={(index) =>
                            this.setState((prevValue) => ({
                                ...prevValue,
                                tabIndex: index,
                                submittedFilterData: {},
                                pagination: {
                                    totalData: 1,
                                    page: 1,
                                    limit: 5,
                                },
                            }))
                        }
                    >
                        <TabList>
                            <Tab>Belum PDI</Tab>
                            <Tab>Sudah PDI</Tab>
                        </TabList>
                        <TabPanel>
                            <BelumPDI
                                state={this.state}
                                kodeCabang={this.state.kodeCabang?.value}
                                onFetchData={this.fetchBelumPDI}
                                onSetState={this.handleSetState}
                                userAccess={this.state.userAccess}
                            />
                        </TabPanel>
                        <TabPanel>
                            <SudahPDI
                                state={this.state}
                                kodeCabang={this.state.kodeCabang?.value}
                                onFetchData={this.fetchSudahPDI}
                                onSetState={this.handleSetState}
                                userAccess={this.state.userAccess}
                            />
                        </TabPanel>
                    </Tabs>
                </Container>
                {this.state.loading && <SimpleLoadingOverlay active={this.state.loading}/>}
            </>
        );
    }
}

const
    mapDispatchToProps = (dispatch) => {
        return {
            setError: (payload) => dispatch(ErrorAction.setError(payload)),
        };
    };

export default connect(null, mapDispatchToProps)(Pdi);
